import { ref } from 'vue';
import translateI18 from '@/hooks/translateI18';

export function CustomForm(props, { emit }) {

  const { translate } = translateI18();
  const customForm = ref<HTMLElement | null>(null);

  return {
    translate,
    customForm,
  };
}
